<!-- Google Sign In Button Container -->
<div class="login-container">
  <div [id]="'google-signin-button' + buttonIdSuffix"></div>
</div>

<div class="login-container" *ngIf="isAppRoute && user">
  <!-- If we're in app route and user is logged in, show nothing or a minimal indicator if needed -->
</div>
